import { DatePicker } from 'antd'
import { RangePickerProps } from 'antd/es/date-picker'

import './RangePicker.css'

const { RangePicker: _RangePicker } = DatePicker

const RangePicker = ({ className, ...props }: RangePickerProps) => {
  return (
    <_RangePicker
      className={`customRangePicker ${className}`}
      {...props}
    />
  )
}

export default RangePicker
